import type { Blocker } from '@remix-run/react'
import {
  Modal,
  ModalConfirmButton,
  ModalContent,
  ModalDismissButton,
  ModalTitle,
} from '~/components/ui/Modal'
import { Paragraph } from '~/components'

export function UnsavedChangesModal({ blocker }: { blocker: Blocker }) {
  const handleClose = () => {
    if (blocker.state === 'blocked') blocker.reset()
  }
  const handleConfirm = () => {
    if (blocker.state === 'blocked') blocker.proceed()
  }

  return (
    <Modal visible={blocker.state === 'blocked'} onClose={handleClose} onConfirm={handleConfirm}>
      <ModalTitle text="Warnung: Ungespeicherte Änderungen" />
      <ModalContent>
        <div className="my-4">
          <Paragraph>
            Wenn Sie fortfahren, werden diese Änderungen verloren gehen. Sind Sie sicher, dass Sie
            die Seite verlassen möchten?
          </Paragraph>
        </div>
      </ModalContent>
      <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
        <ModalDismissButton text="Auf der Seite bleiben" variant="secondary" />
        <ModalConfirmButton text="Seite verlassen" />
      </div>
    </Modal>
  )
}
